import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { globalStyle, style } from '@vanilla-extract/css';

export const postCardContainerBase = style({
  transition: 'background-color 0.2s',
  position: 'relative',

  selectors: {
    '&[role="link"]': {
      cursor: 'pointer',
    },
    '&[data-highlighted]': {
      backgroundColor: '#DDD4F533',
    },
    '&[data-deleted]': {
      opacity: 0.7,
    },
  },
});

export const postCardContainer = style([
  postCardContainerBase,
  {
    display: 'grid',

    // looks like safari doesn't like empty grid areas and 'auto' expands it magically
    // https://synoptic0.slack.com/archives/C062U3NE163/p1721151062460009
    gridAutoRows: 'minmax(min-content, max-content)',

    ...responsiveStyle({
      mobile: {
        padding: space.s16,
        gridTemplateAreas: `
        "top-header"
        "header"
        "reputation"
        "content"
        "footer"
        "hidden"
      `,
      },
      tablet: {
        padding: `${space.s32}px ${space.s32}px ${space.s24}px ${space.s32}px`,
        gridTemplateAreas: `
        "top-header top-header"
        "header header"
        "content reputation"
        "footer footer"
        "hidden hidden"
      `,
        gridTemplateColumns: '1fr auto',
      },
      desktop: {
        padding: `${space.s32}px ${space.s40}px ${space.s24}px ${space.s40}px`,
      },
    }),
  },
]);

export const postCardHeader = style({
  gridArea: 'header',
  paddingBottom: space.s16,
  borderBottom: `1px solid ${themeVars.container.border.default}`,
  minWidth: 0,
  display: 'flex',

  ...responsiveStyle({
    mobile: {
      alignItems: 'start',
    },
    tablet: {
      alignItems: 'center',
    },
  }),
});

export const postCardReposted = style({
  paddingBottom: space.s16,
  display: 'flex',
  alignContent: 'center',
  alignItems: 'center',
});

export const postCardRepostedLink = style({
  ':hover': {
    textDecoration: 'underline',
  },
});

export const postCardTopHeaderContainer = style({
  display: 'flex',
  flexDirection: 'column',
});

export const postCardRepostedText = style({
  paddingLeft: space.s8,
  fontSize: '12px',
});

export const postCardHeaderContent = style({
  display: 'flex',
  rowGap: space.s14,
  minWidth: 0,

  ...responsiveStyle({
    mobile: {
      flexDirection: 'column',
    },
    tablet: {
      flexDirection: 'row',
    },
  }),
});

export const postCardActionsMenu = style({
  marginLeft: 'auto',
});

export const postCardContent = style({
  gridArea: 'content',

  display: 'flex',
  flexDirection: 'column',
  gap: space.s16,
  paddingTop: space.s20,
  paddingBottom: space.s20,

  ...responsiveStyle({
    tablet: { paddingRight: space.s24 },
    desktop: { paddingRight: space.s32 },
  }),
});

export const postCardBody = style({
  flexGrow: 1,
});

export const postCardBodyWithDisabledLinks = style({
  flexGrow: 1,
});

globalStyle(`.${postCardBodyWithDisabledLinks} a`, {
  pointerEvents: 'none',
});

export const postCardDeletedPlaceholder = style({
  minHeight: '110px',
});
export const postCardDate = style({
  ...typography['labelMd'],
  color: themeVars.container.foreground.tertiary,
});

export const postCardFooter = style([
  {
    gridArea: 'footer',
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: `1px solid ${themeVars.container.border.default}`,
    paddingTop: space.s12,
    rowGap: space.s8,
    minWidth: 0,
  },
  responsiveStyle({
    mobile: {
      flexDirection: 'column',
    },
    desktop: {
      flexDirection: 'row-reverse',
      justifyContent: 'start',
      alignItems: 'center',
    },
  }),
]);

export const postCardLabels = style([
  {
    display: 'flex',
    gap: space.s16,
    overflowX: 'auto',
    scrollbarWidth: 'none',
    alignItems: 'center',
  },
  responsiveStyle({
    desktop: { paddingLeft: space.s24 },
  }),
]);

export const postCardActions = style({
  display: 'flex',
  gap: space.s12,
  paddingTop: space.s8,
  paddingBottom: space.s8,
  paddingRight: space.s24,
  flexWrap: 'wrap',

  ...responsiveStyle({
    desktop: {
      borderRight: `1px solid ${themeVars.container.border.default}`,
    },
  }),
});

export const postCardDateContainer = style({
  display: 'flex',
  gap: space.s8,
  alignItems: 'center',
});
